/**
 * Created by linql on 2019/12/16.
 */

/**
 * 验收手机号码是否合法
 * @param {*} $poneInput 
 */
export function isPoneAvailable(poneInput) {
  var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
  if (!myreg.test(poneInput)) {
    return false;
  } else {
    return true;
  }
}

/**
 * 是否合法密码
 * @param {*} str 
 */
export function isvalidPassword(str) {
  let pwdRegexModel1 = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9])?.{6,18}');
  let pwdRegexModel2 = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])?(?=.*[^a-zA-Z0-9]).{6,18}');
  let pwdRegexModel3 = new RegExp('(?=.*[0-9])?(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{6,18}');
  return pwdRegexModel1.test(str) || pwdRegexModel2.test(str) || pwdRegexModel3.test(str)
}

/**
 * 是否合法用户名
 * @param {*} str 
 */
export function isvalidUsername(str) {
  if (str.trim().length < 4) {
    return false
  } else {
    return true
  }
}

/* 合法uri*/
export function validateURL(textval) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return urlregex.test(textval)
}

/* 小写字母*/
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/* 大写字母*/
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/* 大小写字母*/
export function validateAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * validate email
 * @param email
 * @returns {boolean}
 */
export function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}